import type { Domain } from 'auth-common/domain';
import { Const } from 'auth-common/shared';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

type Project = Domain.Object.Project;

export const latestProjectIdAtom = atomWithStorage<Project['id'] | undefined>(Const.LocalStorage.LatestProjectId, undefined, undefined, {
  getOnInit: true,
});
export const useLatestProjectId = () => {
  const [latestProjectId, setLatestProjectId] = useAtom(latestProjectIdAtom);
  return { latestProjectId, setLatestProjectId };
};
